import {
    useEffect,
    useState,
} from "react";

import {
    useNavigate,
    useParams,
} from "react-router-dom";

import {
    getSampleIssue,
} from "services/api/sampleTrackingApi";

import ReturnModal from "../ReturnModal";
import ConversionModal from "../ConversionModal";

import {
    showError,
} from "utils/toast";


export default function SampleTrackingDetail() {

    const {
        id,
    } = useParams();


    const navigate =
        useNavigate();


    const [
        item,
        setItem,
    ] = useState(null);


    const [
        loading,
        setLoading,
    ] = useState(false);


    const [
        returnOpen,
        setReturnOpen,
    ] = useState(false);


    const [
        conversionOpen,
        setConversionOpen,
    ] = useState(false);


    const loadData =
        async () => {

            try {

                setLoading(
                    true
                );


                const response =
                    await getSampleIssue(
                        id
                    );


                setItem(
                    response?.data?.sampleIssue ||
                    null
                );

            } catch (
            error
            ) {

                showError(
                    error?.response?.data?.message ||
                    "Unable to load sample issue."
                );

            } finally {

                setLoading(
                    false
                );

            }

        };


    useEffect(
        () => {

            loadData();

        },
        [
            id,
        ]
    );


    if (loading) {

        return (
            <div
                className="
                    mt-10
                    rounded-2xl
                    bg-white
                    p-10
                    text-center
                "
            >
                Loading sample...
            </div>
        );

    }


    if (!item) {

        return (
            <div
                className="
                    mt-10
                    rounded-2xl
                    bg-white
                    p-10
                    text-center
                "
            >
                Sample issue not found.
            </div>
        );

    }


    const summary =
        item.summary || {};


    return (

        <div
            className="
                mt-5
                space-y-5
            "
        >

            {/* HEADER */}

            <div
                className="
                    flex
                    items-center
                    justify-between
                    rounded-2xl
                    bg-white
                    p-5
                    shadow-sm
                "
            >

                <div>

                    <h1
                        className="
                            text-2xl
                            font-bold
                            text-navy-700
                        "
                    >
                        Sample Issue #
                        {item.id}
                    </h1>

                    <p
                        className="
                            text-sm
                            text-gray-500
                        "
                    >
                        {item.book?.title || "-"}
                    </p>

                </div>


                <button
                    type="button"
                    onClick={() =>
                        navigate(
                            "/admin/sample-tracking"
                        )
                    }
                    className="
                        rounded-lg
                        border
                        px-4
                        py-2
                        text-sm
                    "
                >
                    Back
                </button>

            </div>


            {/* SUMMARY */}

            <div
                className="
                    grid
                    grid-cols-2
                    gap-4
                    md:grid-cols-4
                "
            >

                <div
                    className="
                        rounded-2xl
                        bg-white
                        p-5
                        shadow-sm
                    "
                >
                    <div className="text-sm text-gray-500">
                        Issued
                    </div>

                    <div
                        className="
                            mt-2
                            text-2xl
                            font-bold
                        "
                    >
                        {
                            summary.issuedQuantity ||
                            0
                        }
                    </div>
                </div>


                <div
                    className="
                        rounded-2xl
                        bg-white
                        p-5
                        shadow-sm
                    "
                >
                    <div className="text-sm text-gray-500">
                        Returned
                    </div>

                    <div
                        className="
                            mt-2
                            text-2xl
                            font-bold
                            text-green-600
                        "
                    >
                        {
                            summary.returnedQuantity ||
                            0
                        }
                    </div>
                </div>


                <div
                    className="
                        rounded-2xl
                        bg-white
                        p-5
                        shadow-sm
                    "
                >
                    <div className="text-sm text-gray-500">
                        Converted
                    </div>

                    <div
                        className="
                            mt-2
                            text-2xl
                            font-bold
                            text-purple-600
                        "
                    >
                        {
                            summary.convertedQuantity ||
                            0
                        }
                    </div>
                </div>


                <div
                    className="
                        rounded-2xl
                        bg-white
                        p-5
                        shadow-sm
                    "
                >
                    <div className="text-sm text-gray-500">
                        Remaining
                    </div>

                    <div
                        className="
                            mt-2
                            text-2xl
                            font-bold
                            text-orange-600
                        "
                    >
                        {
                            summary.remainingQuantity ||
                            0
                        }
                    </div>
                </div>

            </div>


            {/* DETAILS */}

            <div
                className="
                    rounded-2xl
                    bg-white
                    p-6
                    shadow-sm
                "
            >

                <h2
                    className="
                        mb-5
                        text-lg
                        font-bold
                    "
                >
                    Sample Details
                </h2>


                <div
                    className="
                        grid
                        grid-cols-1
                        gap-5
                        md:grid-cols-2
                    "
                >

                    <div>
                        <div className="text-xs text-gray-500">
                            School
                        </div>

                        <div className="mt-1 font-semibold">
                            {
                                item.school?.name ||
                                "-"
                            }
                        </div>
                    </div>


                    <div>
                        <div className="text-xs text-gray-500">
                            Sales Person
                        </div>

                        <div className="mt-1 font-semibold">
                            {
                                item.employee?.name ||
                                "-"
                            }
                        </div>
                    </div>


                    <div>
                        <div className="text-xs text-gray-500">
                            Book
                        </div>

                        <div className="mt-1 font-semibold">
                            {
                                item.book?.title ||
                                "-"
                            }
                        </div>
                    </div>


                    <div>
                        <div className="text-xs text-gray-500">
                            Issue Date
                        </div>

                        <div className="mt-1 font-semibold">
                            {
                                item.issueDate
                                    ? new Date(
                                        item.issueDate
                                    ).toLocaleDateString(
                                        "en-IN"
                                    )
                                    : "-"
                            }
                        </div>
                    </div>

                </div>

            </div>


            {/* ACTIONS */}

            <div
                className="
                    flex
                    flex-wrap
                    gap-3
                    rounded-2xl
                    bg-white
                    p-5
                    shadow-sm
                "
            >

                {
                    summary.remainingQuantity > 0 &&
                    item.returnStatus !== "cancelled" && (
                        <button
                            type="button"
                            onClick={() =>
                                setReturnOpen(
                                    true
                                )
                            }
                            className="
                                rounded-xl
                                bg-green-500
                                px-5
                                py-3
                                text-sm
                                font-semibold
                                text-white
                            "
                        >
                            Record Return
                        </button>
                    )
                }


                {
                    summary.remainingQuantity > 0 &&
                    item.returnStatus !== "cancelled" && (
                        <button
                            type="button"
                            onClick={() =>
                                setConversionOpen(
                                    true
                                )
                            }
                            className="
                                rounded-xl
                                bg-purple-500
                                px-5
                                py-3
                                text-sm
                                font-semibold
                                text-white
                            "
                        >
                            Record Conversion
                        </button>
                    )

                }

            </div>


            {/* RETURNS */}

            <div
                className="
                    rounded-2xl
                    bg-white
                    p-6
                    shadow-sm
                "
            >

                <h2
                    className="
                        mb-4
                        text-lg
                        font-bold
                    "
                >
                    Returns
                </h2>


                {
                    !item.returns?.length ? (

                        <div
                            className="
                                text-sm
                                text-gray-500
                            "
                        >
                            No returns recorded.
                        </div>

                    ) : (

                        <div className="space-y-3">

                            {item.returns.map(
                                (entry) => (

                                    <div
                                        key={
                                            entry.id
                                        }
                                        className="
                                            rounded-xl
                                            border
                                            p-4
                                        "
                                    >

                                        <div
                                            className="
                                                flex
                                                justify-between
                                            "
                                        >

                                            <span>
                                                {
                                                    entry.quantity
                                                }{" "}
                                                copy/copies
                                            </span>

                                            <span
                                                className="
                                                    capitalize
                                                    text-green-600
                                                "
                                            >
                                                {
                                                    entry.condition
                                                }
                                            </span>

                                        </div>

                                        <div
                                            className="
                                                mt-1
                                                text-xs
                                                text-gray-500
                                            "
                                        >
                                            {
                                                entry.returnDate
                                                    ? new Date(
                                                        entry.returnDate
                                                    ).toLocaleDateString(
                                                        "en-IN"
                                                    )
                                                    : "-"
                                            }
                                        </div>

                                    </div>

                                )
                            )}

                        </div>

                    )
                }

            </div>


            {/* CONVERSIONS */}

            <div
                className="
                    rounded-2xl
                    bg-white
                    p-6
                    shadow-sm
                "
            >

                <h2
                    className="
                        mb-4
                        text-lg
                        font-bold
                    "
                >
                    Conversions
                </h2>


                {
                    !item.conversions?.length ? (

                        <div
                            className="
                                text-sm
                                text-gray-500
                            "
                        >
                            No conversions recorded.
                        </div>

                    ) : (

                        <div className="space-y-3">

                            {
                                item.conversions.map(
                                    (entry) => (

                                        <div
                                            key={
                                                entry.id
                                            }
                                            className="
                                                rounded-xl
                                                border
                                                p-4
                                            "
                                        >

                                            <div
                                                className="
                                                    flex
                                                    justify-between
                                                "
                                            >

                                                <span>
                                                    {
                                                        entry.quantity
                                                    }{" "}
                                                    converted
                                                </span>

                                                <span
                                                    className="
                                                        font-semibold
                                                        text-purple-600
                                                    "
                                                >
                                                    {
                                                        entry.orderAmount
                                                            ? `₹${entry.orderAmount}`
                                                            : "-"
                                                    }
                                                </span>

                                            </div>


                                            {
                                                entry.orderReference && (
                                                    <div
                                                        className="
                                                            mt-1
                                                            text-sm
                                                        "
                                                    >
                                                        Order:{" "}
                                                        {
                                                            entry.orderReference
                                                        }
                                                    </div>
                                                )
                                            }

                                        </div>

                                    )
                                )
                            }

                        </div>

                    )
                }

            </div>


            {/* RETURN MODAL */}

            <ReturnModal
                open={
                    returnOpen
                }

                item={
                    item
                }

                onClose={() =>
                    setReturnOpen(
                        false
                    )
                }

                reload={
                    loadData
                }
            />


            {/* CONVERSION MODAL */}

            <ConversionModal
                open={
                    conversionOpen
                }

                item={
                    item
                }

                onClose={() =>
                    setConversionOpen(
                        false
                    )
                }

                reload={
                    loadData
                }
            />

        </div>
    );
}